import { render, staticRenderFns } from "./SMSTextBox.vue?vue&type=template&id=5f86ac98&scoped=true&"
import script from "./SMSTextBox.vue?vue&type=script&lang=js&"
export * from "./SMSTextBox.vue?vue&type=script&lang=js&"
import style0 from "./SMSTextBox.vue?vue&type=style&index=0&id=5f86ac98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86ac98",
  null
  
)

export default component.exports